import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { File } from '../_models/file';
import { Workstep } from '../_models/workstep';
import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class FileService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}


  getFiles(searchParams): Observable<File[]> {

    console.log('-->--> Ejecutando servicio getFiles.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<File[]>(this.globals.apiUrl + '/files', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getFiles: ')), // + JSON.stringify(data))),
        catchError(this.handleError<File[]>('getFiles', [])
      ));
  }

  getAllFiles(): Observable<File[]> {

    console.log('-->--> Ejecutando servicio getAllFiles');

    return this.http.get<File[]>(this.globals.apiUrl + '/files')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllFiles: ' + JSON.stringify(data))),
        catchError(this.handleError<File[]>('getAllFiles', [])
      ));
  }

  getFile(searchParams): Observable<File> {

    console.log('-->--> Ejecutando servicio getFile');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('id', searchParams.id)
    };
    return this.http.get<File>(this.globals.apiUrl + '/file', options)
      .pipe(
        tap(  _ => this.log('get file')),
        catchError(this.handleError<File>('getFile', null)
      ));
  }

  updateFile(fileIn: File): Observable<File> {

    console.log('-->--> Ejecutando servicio updateFile');
    console.log(fileIn);
    console.log('---------------');

    let options = {};
    if (fileIn.id === null || fileIn.id === undefined) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', fileIn.id.toString()) };
    }

    return this.http.put<File>(this.globals.apiUrl + '/file', fileIn, options)
      .pipe(
        tap(  _ => this.log('updated file')),
        catchError(this.handleError<File>('updateFile', null)
      ));
  }

  optimizerFile(fileListIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio optimizerFile.');
    console.log(fileListIn);
    console.log('---------------');

    // let params = new HttpParams();

    // if (fileListIn !== null && fileListIn !== undefined) {
    //   for (const key in fileListIn) {
    //     // Para controlar que exista un elemento con esa key.
    //     if (fileListIn.hasOwnProperty(key)) {
    //       params = params.set(key, fileListIn[key]);
    //     }
    //   }
    // }

    // Add safe, URL encoded search parameter if there is a search term
    // const options = { params: params };

    let options = {};

    options = { params: new HttpParams()
      .set('path', fileListIn.path ? fileListIn.path.toString() : null)
      .set('ancho_muela', fileListIn.ancho_muela ? fileListIn.ancho_muela.toString() : null)
      .set('solapamiento', fileListIn.solapamiento ? fileListIn.solapamiento.toString() : null)
      .set('ruta_destino', fileListIn.ruta_destino ? fileListIn.ruta_destino.toString() : null)
      .set('lotes', fileListIn.lotes ? fileListIn.lotes.toString() : null)
      .set('grupo', fileListIn.grupo ? fileListIn.grupo.toString() : null)
    };

    return this.http.get<any>(this.globals.apiUrl + '/optimizer', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde optimizerFile: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any>('optimizerFile', [])
      ));
  }

  autoBatchHeartbeatTouch(payloadIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio autoBatchHeartbeatTouch.');
    console.log(payloadIn);
    console.log('---------------');

    const options = {};
    return this.http.put<any>(this.globals.apiUrl + '/auto_batch_heartbeat', payloadIn ? payloadIn : {}, options)
      .pipe(
        tap( data => console.log(' -> Heartbeat AutoBatch actualizado: ')),
        catchError(this.handleError<any>('autoBatchHeartbeatTouch', { response: false, data: null }))
      );
  }

  autoBatchHeartbeatGet(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio autoBatchHeartbeatGet.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };
    return this.http.get<any>(this.globals.apiUrl + '/auto_batch_heartbeat', options)
      .pipe(
        tap( data => console.log(' -> Heartbeat AutoBatch obtenido: ')),
        catchError(this.handleError<any>('autoBatchHeartbeatGet', { response: false, data: null }))
      );
  }

  getInfoFileList(fileListIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getInfoFileList.');
    console.log(fileListIn);
    console.log('---------------');

    let params = new HttpParams();

    if (fileListIn !== null && fileListIn !== undefined) {
      for (const key in fileListIn) {
        // Para controlar que exista un elemento con esa key.
        if (fileListIn.hasOwnProperty(key)) {
          params = params.set(key, fileListIn[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<any>(this.globals.apiUrl + '/info_files', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getInfoFileList: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any>('getInfoFileList', [])
      ));
  } // End function getInfoFileList

  createFile(fileIn: File): Observable<File> {

    console.log('-->--> Ejecutando servicio createFile');
    console.log(fileIn);
    console.log('---------------');

    let options = {};

    return this.http.post<File>(this.globals.apiUrl + '/file', fileIn, options)
      .pipe(
        tap(  _ => this.log('created file')),
        catchError(this.handleError<File>('createFile', null)
      ));
  } // End function createFile

  deleteFile(fileIn: File): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteFile');
    console.log(fileIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', fileIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/file', options)
      .pipe(
        tap(  _ => this.log('deleted file')),
        catchError(this.handleError<bigint>('deleteFile', null)
      ));
  } // End function deleteFile

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // ---------------
  //  PASOS TRABAJO
  // ---------------

  getWorksteps(searchParams): Observable<Workstep[]> {

    console.log('-->--> Ejecutando servicio getWorksteps.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Workstep[]>(this.globals.apiUrl + '/worksteps', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getWorksteps: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Workstep[]>('getWorksteps', [])
      ));
  }

  // ----------
  //  IMPRIMIR
  // ----------
  printFile(fileIn): Observable<any> {

    console.log('-->--> Ejecutando servicio printFile.');
    // console.log(fileIn);
    // console.log('---------------');

    let options = {};
    // if (fileIn.id === null) {
    //   options = { params: new HttpParams()
    //     .set('id', '0') };
    // } else {
    //   options = { params: new HttpParams()
    //     .set('id', fileIn.id.toString()) };
    // }

    return this.http.put<any>(this.globals.apiUrl + '/file_print', fileIn, options)
      .pipe(
        tap(  _ => this.log('print file')),
        catchError(this.handleError<any>('printFile', null)
      ));
  }

  printSheets(sheetListIn): Observable<any> {

    console.log('-->--> Ejecutando servicio printSheets.');
    console.log(sheetListIn);
    // console.log('---------------');

    let options = {};
    // if (fileIn.id === null) {
    //   options = { params: new HttpParams()
    //     .set('id', '0') };
    // } else {
    //   options = { params: new HttpParams()
    //     .set('id', fileIn.id.toString()) };
    // }

    return this.http.put<any>(this.globals.apiUrl + '/print_sheets', sheetListIn, options)
      .pipe(
        tap(  _ => this.log('print sheets')),
        catchError(this.handleError<any>('printSheets', null)
      ));
  }

  printEasels(easelListIn): Observable<any> {

    console.log('-->--> Ejecutando servicio printEasels.');
    console.log(easelListIn);
    // console.log('---------------');

    let options = {};
    // if (fileIn.id === null) {
    //   options = { params: new HttpParams()
    //     .set('id', '0') };
    // } else {
    //   options = { params: new HttpParams()
    //     .set('id', fileIn.id.toString()) };
    // }

    return this.http.put<any>(this.globals.apiUrl + '/print_easels', easelListIn, options)
      .pipe(
        tap(  _ => this.log('print easels')),
        catchError((error: any) => {
          const backendError = error && error.error ? error.error : null;
          const errorMessage = backendError && backendError.msg
            ? backendError.msg
            : (error && error.message
              ? error.message
              : (error ? error.toString() : 'No se ha podido generar el documento.'));
          console.error(error);
          this.log('printEasels failed: ' + errorMessage);
          return of({
            error: errorMessage,
            code: backendError && backendError.code ? backendError.code : '',
            action: easelListIn && easelListIn.action ? easelListIn.action : '',
            back: easelListIn && easelListIn.back ? easelListIn.back : ''
          });
        }
      ));
  }

  // ----------------------------------
  // 	GUARDAR DATOS PIEZAS OPTIMIZADAS
  // ----------------------------------
  // Obtener la información de piezas obtenidas en las optimizaciones.
  getPiece(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getOptiPiece.');
    console.log(searchParams);
    console.log('---------------');
    
    // NOTA: Transformación para poder buscar el caracter "+" dentro del campo.
    if (searchParams['f_mat'] !== null && searchParams['f_mat'] !== undefined) {
      searchParams['f_mat'] = searchParams['f_mat'].replace('+', '&#43;')
    }

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Workstep[]>(this.globals.apiUrl + '/floor_pieces', options)
      .pipe(
        tap( data => console.log(' -> Datos piezas obtenidos desde getPiece: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Workstep[]>('getPiece', [])
      ));
  } // End function getPiece
  
  // ----------------------------------
  // 	GUARDAR DATOS PIEZAS OPTIMIZADAS
  // ----------------------------------

  // Obtener la información de piezas obtenidas en las optimizaciones.
  getOptiPiece(searchParams: any): Observable<any> {

    console.log('-->--> Ejecutando servicio getOptiPiece.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Workstep[]>(this.globals.apiUrl + '/opti_pieces', options)
      .pipe(
        tap( data => console.log(' -> Datos piezas obtenidos desde getOptiPiece: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Workstep[]>('getOptiPiece', [])
      ));
  } // End function getOptiPiece

  // Guardar la información de piezas obtenidas en una optimización.
  saveOptiPiece(optiPieceIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio saveOptiPiece');
    console.log(optiPieceIn);
    console.log('---------------');

    let options = {};

    return this.http.post<any>(this.globals.apiUrl + '/opti_piece', optiPieceIn, options)
      .pipe(
        tap(  _ => this.log('save opti_piece')),
        catchError(this.handleError<any>('saveOptiPiece', null)
      ));
  } // End function saveOptiPiece
  
  // Guardar en ORACLE la información de piezas obtenidas en una optimización.
  saveOptiPieceOracle(optiPieceIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio saveOptiPieceOracle');
    console.log(optiPieceIn);
    console.log('---------------');

    let options = {};

    return this.http.post<any>('https://production.vidrioservice.com/api/get_pdf?pax=511000&usx=norglass&name=firma_envio_202408011955.pdf', optiPieceIn, options)
      .pipe(
        tap(  _ => this.log('save opti_piece_oracle')),
        catchError(this.handleError<any>('saveOptiPieceOracle', null)
      ));
  } // End function saveOptiPieceOracle

  // ----------------
  //      EMAILS
  // ----------------
  sendEmail(searchParams): Observable<any> {

    console.log('-->--> Ejecutando servicio sendEmail.');
    // console.log(searchParams);
    // console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    const options = { params: params };

    return this.http.get<any>(this.globals.apiUrl + '/send_email', options)
      .pipe(
        tap( data => console.log(' -> Respuesta obtenida desde sendEmail: ')), // + JSON.stringify(data))),
        catchError(this.handleError<any>('sendEmail', [])
      ));
  } // End function sendEmail


  // ----------------
  //     ARCHIVOS
  // ----------------

  // Servicio que crea desde el controlador budget.js un archivo
  // csv en el servidor con datos de la estimación del flete.
  makeCsv(params): Observable<number> {

    console.log('-->--> Ejecutando servicio makeCsv.');
    console.log(params);
    console.log('---------------');

    let options = {};
    // if (budgetIn.budget.id === null) {
    //   options = { params: new HttpParams()
    //     .set('id', '0') };
    // } else {
    //   options = { params: new HttpParams()
    //     .set('id', budgetIn.budget.id.toString()) };
    // }

    return this.http.put<number>(this.globals.apiUrl + '/file_csv', params, options)
      .pipe(
        tap(  _ => this.log('makeCsv budget')),
        catchError(this.handleError<number>('makeCsv', null)
      ));
  } // End service makeCsv

  // Servicio que lee desde el controlador budget.js un archivo
  // csv cuyo nombre/localización es pasado como parámetro.
  readCsv(paramsIn): Observable<any> {

    console.log('-->--> Ejecutando servicio readCsv.');
    console.log(paramsIn);
    console.log('---------------');

    let params = new HttpParams();

    if (paramsIn !== null && paramsIn !== undefined) {
      for (const key in paramsIn) {
        // Para controlar que exista un elemento con esa key.
        if (paramsIn.hasOwnProperty(key)) {
          params = params.set(key, paramsIn[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<any>(this.globals.apiUrl + '/file_read', options)
      .pipe(
        tap(  _ => this.log('readCsv budget')),
        catchError(this.handleError<number>('readCsv', null)
      ));
  } // End service readCsv

  updateFileCSV(fileListIn: any): Observable<any> {

    console.log('-->--> Ejecutando servicio updateFileCSV');
    // console.log(fileListIn);
    console.log('---------------');

    let options = {};
    if (fileListIn.mod === null) {
      options = { params: new HttpParams()
        .set('mod', '0') };
    } else {
      options = { params: new HttpParams()
        .set('mod', fileListIn.mod) };
    }

    return this.http.put<any>(this.globals.apiUrl + '/file_update', fileListIn, options)
      .pipe(
        tap(  _ => this.log('updatedFile CSV')),
        catchError(this.handleError<any>('updateFileCSV', null)
      ));
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
